export default __webpack_public_path__ + "static/media/circle.699803ee.jpg";